import { ModelTranslator } from '@/types/ApiResponseTypes'
import {
  TicketAttachmentRequest,
  TicketHistoryRequestBody,
  isTicketHistoryRequest,
} from '@/types/support/TicketRequestType'
import { dateTimeToString } from '@/utils/common'

class TicketHistoryRequestTranslator implements ModelTranslator<TicketHistoryRequestBody> {
  convertToModel(model: any): TicketHistoryRequestBody {
    if (isTicketHistoryRequest(model)) {
      return {
        date: 'date' in model ? model.date : dateTimeToString(new Date()),
        inputTypeId: 'inputTypeId' in model ? model.inputTypeId : 0,
        actionTypeId: 'actionTypeId' in model ? model.actionTypeId : 0,
        content: 'content' in model ? model.content : '',
        employeeId: 0,
        attachments: [],
      }
    }
    return {} as TicketHistoryRequestBody
  }
  async convertToModelAsync(model: any): Promise<TicketHistoryRequestBody> {
    return new Promise((resolve) => {
      this.encodeAttachments(model.attachments).then((result) => {
        resolve({
          date: 'date' in model ? model.date : dateTimeToString(new Date()),
          inputTypeId: 'inputTypeId' in model ? model.inputTypeId : 0,
          actionTypeId: 'actionTypeId' in model ? model.actionTypeId : 0,
          content: 'content' in model ? model.content : '',
          employeeId: 0,
          attachments: result,
        })
      })
    })
  }

  async encodeAttachments(files: Array<File>): Promise<Array<TicketAttachmentRequest>> {
    return new Promise((resolve) => {
      const att: Array<TicketAttachmentRequest> = []
      const proms: any = []
      for (const key in files) {
        const file = files[key]
        proms.push(
          this.toBase64(file).then((result) => {
            if (typeof result != 'string') result = ''

            result = result != '' && result.indexOf(',') !== -1 ? result.split(',')[1] : result
            att.push({
              fileName: file.name,
              data: result,
            })
          }),
        )
      }
      Promise.all(proms).then(() => {
        resolve(att)
      })
    })
  }

  async toBase64(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }
}
export default new TicketHistoryRequestTranslator()
